import MaterialExTable from "../../../../components/tables/MaterialExTable";
import useGetJobConfigReport from "../hooks/useGetJobConfigReport";
import ReactTooltip from "react-tooltip";
const ReportDetailsTable = ({ data }) => {
  const { data: jobConfigData, isLoading: isJobConfigLoading } =
    useGetJobConfigReport(data.jobConfigId ?? 0);

  const columns = [
    {
      title: "Report Name",
      field: "reportName",
      render: (rowData) => {
        return (
          <div className="cursor-pointer blueAndBold underline ">
            {rowData.reportName}
          </div>
        );
      },
    },
    {
      title: "Job ID",
      field: "jobConfigId",
      render: (rowData) => {
        return <>{rowData.jobConfigId}</>;
      },
    },
    {
      title: "Source System",
      field: "sourceSystem",
    },
    {
      title: "Script Path",
      field: "scriptPath",
      render: (rowData) => {
        return (
          <div className="">
            <ReactTooltip place="top" effect="solid" type="info" />
            {rowData?.scriptPath?.length > 95 ? (
              <span data-tip={rowData.scriptPath}>
                {rowData.scriptPath.substring(0, 95).trim() + "..."}
              </span>
            ) : (
              rowData.scriptPath
            )}
          </div>
        );
      },
    },

    {
      title: "Is Active",
      field: "isActive",
      render: (rowData) => {
        return <>{rowData.isActive ? "Yes" : "No"}</>;
      },
    },
  ];

  return (
    <>
      <div className="w-full p-2 bg-white">
        <div className="overflow-x-auto grid grid-row">
          <MaterialExTable
            columns={columns}
            data={jobConfigData}
            isLoading={isJobConfigLoading}
            selection={false}
            setOpenModal={false}
            actions={""}
            editable={false}
            toolbar={undefined}
            showTitle={false}
            exportButton={false}
            grouping={undefined}
            search={undefined}
            detailPanel={undefined}
            selectedRows={[]}
            onSelectionChange={undefined}
            isActive={true}
            paging={true}
            searchFieldAlignment={undefined}
            toolbarButtonAlignment={undefined}
            toolBarComponent={undefined}
            panelWidth={""}
            tableRef={undefined}
            onSearchChange={undefined}
            fileName={undefined}
            title={undefined}
          />
        </div>
      </div>
    </>
  );
};

export default ReportDetailsTable;
